module.exports = __webpack_public_path__ + "img/leakinstreet.24b249f2.svg";